import React from 'react';
import { motion, Variants } from 'framer-motion';
import './styles.css';

interface Props {
  title: string;
  content: string;
  hueA: number;
  hueB: number;
}

const cardVariants: Variants = {
  offscreen: {
    y: 300,
    opacity: 0
  },
  onscreen: {
    y: 0,
    opacity: 1,
    rotate: 0,
    transition: {
      type: 'spring',
      bounce: 0.4,
      duration: 0.8
    }
  }
};

const hue = (h: number) => `hsl(${h}, 100%, 50%)`;

const VisionMissionCard: React.FC<Props> = ({ title, content, hueA, hueB }) => {
  const background = `linear-gradient(306deg, ${hue(hueA)}, ${hue(hueB)})`;

  return (
    <motion.div
      className="vision-mision-card-container"
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true, amount: 0.8 }}
    >
      <motion.div className="vision-mision-card" style={{ background }} variants={cardVariants}>
        <h2>{title}</h2>
        <p>{content}</p>
      </motion.div>
    </motion.div>
  );
};

export default VisionMissionCard;
